/// <reference path="../include.ts" />

module gpx_visualizer_phase2 {

	export class ProgressManagerProgressEvent extends alm.event.Event {

		public static START:string = "ProgressManagerProgressEvent.START";
		public static PROGRESS:string = "ProgressManagerProgressEvent.PROGRESS";
		public static COMPLETE:string = "ProgressManagerProgressEvent.COMPLETE";





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(eventType:string, target:object, ratio:number) {
			super(eventType, target);
			this.ratio = ratio;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getRatio():number {
			return this.ratio;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private ratio:number;
	}
}
